import { Component, Input, OnInit, PLATFORM_ID, Injectable, Inject  } from '@angular/core';
import { isPlatformServer, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ContentfulService } from '../../_services/contentful.service';
import { Observable, from } from 'rxjs';
import { LandingPage, FavIcon } from '../../_models/landing-page.model';
import { FormFlow } from '../../_models/form-dynamic.model';
import { Header } from '../../_models/header.model';
import { Footer } from '../../_models/footer.model';
import { Theme, ColorPicker } from '../../_models/theme.model';
import { Asset, Entry } from 'contentful';
import { environment } from '../../../enviroments/environment';
import { Renderer2 } from '@angular/core';
import { ContentfulLivePreview, ContentfulLivePreviewInitConfig } from '@contentful/live-preview';
import { Article } from '../../_models/article.model';
import { MetaTagsManagementService } from '../../_services/meta-tags-management.service';
import { Title } from '@angular/platform-browser';
import { CssInjectorService } from '../../_services/css-injector.service';

import { ThankYouPage } from '../../_models/thank-you-page.model';
import { VERTICALS } from '../../_static-settings/verticals.data';
import { FormDataService } from '../../_services/form-data.service';
import { IPQSService } from '../../_services/ipqs.service';
import { WindowService } from '../../_services/window.service';

@Component({
  selector: 'app-landing-page-v1',
  standalone: false,
  templateUrl: './landing-page-v1.component.html',
  styleUrl: './landing-page-v1.component.css'
})
export class LandingPageV1Component implements OnInit {
  @Input() landingPageID: string | null = "";
  @Input() landingPageTypeID: string | null = "";


  private styleElement: HTMLStyleElement | null = null;
  landingData: any = {};
  formData: { [key: string]: any } = {};
  isLoading = true;
  error = false;

  landingPage: Entry<LandingPage> | undefined;
  title: string = "";
  favIcon: Entry<FavIcon> | undefined;
  headerContent: Entry<Header> | undefined
  formFlowConfig: Entry<FormFlow> | undefined;
  thankYouPageContent: Entry<ThankYouPage> | undefined;
  articlesConfig: Array<Entry<Article>> | undefined;
  footerContent: Entry<Footer> | undefined;
  themeContent: Entry<Theme> | undefined;
  vertical: string = "";

  constructor(
    private contentful: ContentfulService,
    private renderer: Renderer2,
    private metaTagsManagementService: MetaTagsManagementService,
    private cssInjectorService: CssInjectorService,
    private formDataService: FormDataService,
    private IPQS: IPQSService,
    private windowService: WindowService,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document,

  ) {}

  ngOnInit() {
    if (this.landingPageID) {
      this.loadLandingData(this.landingPageID);
    }    
    this.formDataService.clearStorageByLoad();
    this.formDataService.initializeUrlParams();
    this.formDataService.initializeFormData();
    
  }

  private loadLandingData(landingPageID: string | null) {
    from(this.contentful.getLandingPage(landingPageID)).subscribe({
      next: (page: Entry<LandingPage>) => {           
        this.landingPage = page as Entry<LandingPage>;
        this.title = page.fields.title as any as string;
        this.favIcon = page.fields.favIcon as unknown as Entry<FavIcon>;
        this.headerContent = page.fields.header as unknown as Entry<Header>;
        this.formFlowConfig = page.fields.form as unknown as Entry<FormFlow>;
        this.thankYouPageContent = page.fields.thankYouPage as unknown as Entry<ThankYouPage>;  
        this.articlesConfig = page.fields.articles as unknown as Array<Entry<Article>>;
        this.footerContent = page.fields.footer as unknown as Entry<Footer>;
        this.themeContent = page.fields.theme as unknown as Entry<Theme>;  
        this.vertical = page.fields.vertical as any as string;
        this.isLoading = false;

        if(this.favIcon) {
          this.manageFavIcon(this.favIcon);
        }
        if(this.themeContent) {
          this.manageTheme(this.themeContent);
        }
        
        this.metaTagsManagementService.setSeoData(
          {
            title: this.title,
            description: this.title
          }
        )

        var verticalID = VERTICALS.find(v => v.name === this.vertical)?.id || '';                
        this.formData['VerticalID'] = verticalID;
        
        // var IPQS = this.IPQS.getIPQSInfo();
        // console.log(IPQS)
        // if(IPQS) {
        //   this.formData['IPQualityCustomVar1'] = IPQS.success;
        //   this.formData['IPQualityCustomVar2'] = IPQS.bot_status;
        //   this.formData['IPQualityCustomVar3'] = IPQS.fraud_score;
        //   this.formData['IPQualityCustomVar4'] = IPQS.abuse_velocity;
        //   this.formData['IPQualityCustomVar5'] = IPQS.abuse_velocity;

        // }
        
        this.formDataService.updateFormData(this.formData);
      },
      error: (err) => {
        console.error('Error:', err);
        this.isLoading = false;
      }
    });
  }

  _manageTheme(theme: Entry<Theme>) {
    const appMain = this.document.getElementById('app-main');
    if (!appMain) return;

    this.renderer.removeClass(appMain, 'theme-default');
    this.renderer.addClass(appMain, theme.fields.className.toString());

    const element = this.document.querySelector(`.${theme.fields.className}`) as HTMLElement;
    if (!element) return;

    const themeConfig = {
      '--title-color': theme.fields.titleColor?.['value'],
      '--subtitle-color': theme.fields.subTitleColor?.['value'],
      '--element-color-primary': theme.fields.elementsColor1?.['value'],
      '--buttons-color-primary': theme.fields.buttonsColor1?.['value'],
      '--text-color': theme.fields.textColor1?.['value'],
      '--footer-text-color': theme.fields.footerTextColor?.['value'],
    };


    const sizeThemeConfig = {
      '--title-size': (theme.fields.titleFontSizePercentage?.toString()),
      '--subtitle-size': (theme.fields.subtitleFontSize?.toString()),
    }

    Object.entries(themeConfig).forEach(([prop, value]) => {
      const currentValue = getComputedStyle(element).getPropertyValue(prop);
      element.style.setProperty(prop, value || currentValue);
    });

    Object.entries(sizeThemeConfig).forEach(([prop, value]) => {
      const currentValue = getComputedStyle(element).getPropertyValue(prop);
      element.style.removeProperty(prop);
      element.style.setProperty(prop, (value ? value.toString() + '%' : null) || currentValue);
    });

    if(theme.fields.fontFamily) {
      this.document.querySelector('body')?.style.setProperty('font-family', theme.fields.fontFamily.toString())
    }

    var customCSS = theme?.fields?.customCss?.toString() ? theme?.fields?.customCss?.toString(): '';
    this.cssInjectorService.injectCSS(theme.sys.id, customCSS)

    this.cssInjectorService.injectCSS('landing-page', customCSS);
      
  }

  manageTheme(theme: Entry<Theme>) {
    const doc = this.windowService.document;
    if (!doc) return; 

    const appMain = doc.getElementById('app-main');
    if (!appMain) return;

    this.renderer.removeClass(appMain, 'theme-default');
    this.renderer.addClass(appMain, theme.fields.className.toString());

    const element = doc.querySelector(`.${theme.fields.className}`) as HTMLElement;
    if (!element) return;

    const themeConfig = {
      '--title-color': theme.fields.titleColor?.['value'],
      '--subtitle-color': theme.fields.subTitleColor?.['value'],
      '--element-color-primary': theme.fields.elementsColor1?.['value'],
      '--buttons-color-primary': theme.fields.buttonsColor1?.['value'],
      '--text-color': theme.fields.textColor1?.['value'],
      '--footer-text-color': theme.fields.footerTextColor?.['value'],
    };


    const sizeThemeConfig = {
      '--title-size': (theme.fields.titleFontSizePercentage?.toString()),
      '--subtitle-size': (theme.fields.subtitleFontSize?.toString()),
    }

    const getComputedStyle = this.windowService.getComputedStyle.bind(this.windowService);

    Object.entries(themeConfig).forEach(([prop, value]) => {
      const currentValue = getComputedStyle(element)?.getPropertyValue(prop) || '';
      element.style.setProperty(prop, value || currentValue);
    });

    Object.entries(sizeThemeConfig).forEach(([prop, value]) => {
      const currentValue = getComputedStyle(element)?.getPropertyValue(prop) || '';
      element.style.removeProperty(prop);
      element.style.setProperty(prop, (value ? value.toString() + '%' : null) || currentValue);
    });

    if (theme.fields.fontFamily) {
      doc.querySelector('body')?.style.setProperty('font-family', theme.fields.fontFamily.toString());
    }

    var customCSS = theme?.fields?.customCss?.toString() ? theme?.fields?.customCss?.toString() : '';
    this.cssInjectorService.injectCSS(theme.sys.id, customCSS);
    this.cssInjectorService.injectCSS('landing-page', customCSS);
  }  

  manageFavIcon(favIcon: Entry<FavIcon>) {
    var _favIcon = this.document.querySelector('link[rel*=icon]') as HTMLLinkElement;

    var favIconAsset = favIcon.fields.file
    if (favIconAsset['url']) {
      _favIcon.href = favIconAsset['url']
    }
  }
 



}
